import axios from 'axios'
import router from '../router/index'



// export const  baseURL = 'https://m.qsy3d.com' // 线上
// // export const baseURL = 'http://192.168.17.61:9256' // 陈伟


export const baseURL=process.env.NODE_ENV == 'development'?
// ------------本地-----------------------------------------------------------------------
// 'http://192.168.17.61:9256'   //陈伟

'https://m.qsy3d.com/website'   //线上

// ---------------线上--------------------------------------------------------------------
:'https://m.qsy3d.com/website'     //打包 不需要改




function setCookie(cname, cvalue, exdays) {
  //cname 名字
  //cvalue 值
  //exdays 时间            0.01大概25分钟
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/"   //这个很重要代表在那个层级下可以访问cookie
}

function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}

const service = axios.create({
  baseURL: baseURL,
  // headers: {'token': getCookie('_token')},
  withCredentials: false, // 设置是否跨域
  timeout: 60000
})

service.defaults.headers.get['Content-Type'] = 'application/json; charset=UTF-8'

// 请求拦截，可携带Token请求头
service.interceptors.request.use(
  config => {
    if (getCookie('_token')) {
      config.headers.common['token'] = getCookie('_token')
    }
    delete config.data.token  //删除请求的token参数（非请求头）
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    let fullPath = ''
    //   store.dispatch('app/changeSpingFn', false)
    if (res.code == 0 || res.code == 20 || res.code == 9999) {
      return res
    }else if(res.code == 60){
      if(res.obj == "token失效，请重新登录" || res.obj == "token不能为空"){
        setCookie('_token', "", -1)
        setCookie('_isMonthlyKnots', "", -1)
        // res.msg = "token已过期，请重新登录"
        res.msg
        // alert("token失效，请重新登录")
        fullPath = location.hash.replace('#','')
        if(location.hash.indexOf('#/login') == -1){
          router.replace({
            path: '/'
          })
          router.push({
            path: '/login',
            query: {
              fullPath
            }
          })
        }
        // location.href = location.host+'/#/login?fullPath='+fullPath
        return res
      }
    } else {
      console.log(res)
      if (res.code == -2) {
        //   store.dispatch('user/noPowerFn', res.message)
      }
      return Promise.reject(res || '服务器超时')
    }
    // if (res.code !== 0 && res.code !== 200 && res.code !== 20) {
    //   console.log(res)
    //   if (res.code == -2) {
    //   //   store.dispatch('user/noPowerFn', res.message)
    //   }
    //   return Promise.reject(res.msg || '服务器超时')
    // } else {
    //   return res
    // }
  },
  error => {
    //   store.dispatch('app/changeSpingFn', false)
    console.log('err:', error) // for debug
    if (error || error.response) {
      console.log('error',error);
      if (error.response.status == 401 || error.response.status == 403) {
        if (error.response.data.code == -3 || error.response.data.code == 403) {
          // router.push('/401')
        }
      }
      if (error.response.status !== 200) {
        console.log(error)
      }
      // error.message = errorText[error.response.status] || `连接错误${error.response.status}`
    } else {
      console.log('失败')
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/request/request.js